import { get } from '../tools/http';
import { securityService } from '../tools/sequrity_service';
import appBaseUrl from '@/tools/appBaseUrl';

export default {
    state: {
        errorText: '',
        showError: false,
        error: {
            show: false,
            text: '',
        },
    },
    mutations: {
        setErrorText: (state) => {
            state.error.show = true;
            state.error.text = 'Произошла ошибка. Попробуйте позже.';
        },
    },
    actions: {
        deleteProfile: async ctx => {
            try {
                await get('profile', 'user/mark-as-deleted');
            } catch(error) {
                if(error) {
                    ctx.commit('setErrorText');
                }
            } finally {
                securityService.signOut(`${appBaseUrl}delete-profile-message/`);
            }
        },
    },
    getters: {
        getError: state => state.error,
    },
};
